import { Plugin } from '@nuxt/types';
import { INDEX_PAGE } from '~/constants';

const redirectOnError: Plugin = ({ redirect, $api }) => {
  $api.onError(error => {
    if (error.response?.status === 401) {
      redirect(INDEX_PAGE);
    }
  });
};

export default redirectOnError;
